import { FlatButton, SVGButton } from 'components/Buttons';
import styled from 'styled-components';
import colors, { opacity } from 'styles/colors';
import { svgCSSColorOverride } from 'utils/colors';

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  button {
    text-transform: uppercase;
  }

  input {
    position: absolute;
    margin: 15px;
    min-width: 400px;
    left: 0px;
    top: 0px;
  }
`;

export const ButtonsContainer = styled.div<{ visible?: boolean }>`
  position: absolute;
  bottom: 21px;
  right: 120px;
  z-index: 1;
  background-color: ${colors.white};
  border-radius: 4px;

  ${(props) => (!props.visible ? `display: none;` : null)}
`;

export const InnerButtonsContainer = styled.div`
  display: flex;
  border: 1px solid ${colors.fleetOffGray};
  border-radius: 4px;
`;

export const StyledResetButton = styled(FlatButton)`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
`;

export const StyledUndoButton = styled(SVGButton)<{ disabled?: boolean }>`
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  ${({ color = colors.fleetBlue }) => svgCSSColorOverride(color)}

  &:disabled {
    cursor: not-allowed;
    background-color: ${colors.disabledButtonBackground};
    &:hover {
      background-color: ${colors.disabledButtonBackground};
    }

    ${({ color = colors.fleetDarkGray }) => svgCSSColorOverride(opacity(color, 0.4))}
  }
`;

export const StyledRedoButton = styled(SVGButton)`
  border-radius: 0;
  border-left: 1px solid ${colors.fleetOffGray};
  border-right: 1px solid ${colors.fleetOffGray};
  ${({ color = colors.fleetBlue }) => svgCSSColorOverride(color)}
  &:disabled {
    cursor: not-allowed;
    background-color: ${colors.disabledButtonBackground};
    &:hover {
      background-color: ${colors.disabledButtonBackground};
    }

    ${({ color = colors.fleetDarkGray }) => svgCSSColorOverride(opacity(color, 0.4))}
  }
`;

export const EdgeMarker = styled.div`
  position: absolute;
  width: 16px;
  height: 16px;
  left: calc(50% - 8px);
  top: calc(50% - 8px);
  border-radius: 50%;
  background-color: ${colors.white};
  border: 2px solid ${colors.fleetBlue};
  transition: 0.15s background-color ease-in-out;

  &:hover {
    background-color: ${colors.fleetBlue};
    cursor: pointer;

    div {
      display: block;
    }
  }
`;

export const Circle = styled.div<{ radius: number }>`
  position: absolute;
  border-radius: 50%;
  background-color: ${colors.geofencePrimary}60;
  border: 1px solid ${colors.geofenceSecondary}80;

  ${(props) =>
    `
            width: ${props.radius * 2}px;
            height: ${props.radius * 2}px;
            left: calc(50% - ${props.radius}px);
            top: calc(50% - ${props.radius}px);
        `};
`;
